import { EmptyState } from '@app/components/base/EmptyState';
import TvOffIcon from '@mui/icons-material/TvOff';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { youtubeNativeRecentTransmissionsMessages } from './youtube-broadcasts.messages';
import { YoutubeOfflineChip } from './YoutubeOfflineChip';

/** Empty state shown when a YouTube Native station has no recent broadcasts in the last 24 hours. */
export function YoutubeBroadcastsEmptyState() {
  return (
    <EmptyState
      icon={TvOffIcon}
      message={
        <Box my={1}>
          <YoutubeOfflineChip />
        </Box>
      }
      help={
        <FormattedMessage {...youtubeNativeRecentTransmissionsMessages.noRecentBroadcastsHelp} />
      }
    />
  );
}
